import {
  IAdvancedSearchConfiguration,
  IAdvancedSearchQueryConfiguration
} from '../components/case-search/advanced-search-configuration.interface';
import { IgenomicsAction } from '../../core/interfaces/genomics-action.interface';

export const SetAdvancedSearchConfiguration = 'AdvancedSearch.SetAdvancedSearchConfiguration';
export function setAdvancedSearchConfiguration(configuration: IAdvancedSearchConfiguration): IgenomicsAction<IAdvancedSearchConfiguration> {
  return {
    type: SetAdvancedSearchConfiguration,
    payload: configuration
  };
}

